var _a;
import { UnitSuffix } from '../../defs';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var viewHeightToPixel = function (value, options) {
    return value * options.viewHeightPixelValue();
};
var viewHeightToCentimeter = function (value, options) {
    return pixel.cm(viewHeightToPixel(value, options));
};
var viewHeightToMillimeter = function (value, options) {
    return pixel.mm(viewHeightToPixel(value, options));
};
var viewHeightToQuarter = function (value, options) {
    return pixel.Q(viewHeightToPixel(value, options));
};
var viewHeightToInch = function (value, options) {
    return pixel.in(viewHeightToPixel(value, options));
};
var viewHeightToPica = function (value, options) {
    return pixel.pc(viewHeightToPixel(value, options));
};
var viewHeightToPoint = function (value, options) {
    return pixel.pt(viewHeightToPixel(value, options));
};
var viewHeightToREM = function (value, options) {
    return pixel.rem(viewHeightToPixel(value, options), options);
};
var viewHeightToEM = function (value, options) {
    return pixel.em(viewHeightToPixel(value, options), options);
};
var viewHeightToViewWidth = function (value, options) {
    return pixel.vw(viewHeightToPixel(value, options), options);
};
var viewHeightToViewMin = function (value, options) {
    return pixel.vmin(viewHeightToPixel(value, options), options);
};
var viewHeightToViewMax = function (value, options) {
    return pixel.vmax(viewHeightToPixel(value, options), options);
};
export var viewHeight = (_a = {},
    _a[UnitSuffix.Pixel] = viewHeightToPixel,
    _a[UnitSuffix.Centimeter] = viewHeightToCentimeter,
    _a[UnitSuffix.Millimeter] = viewHeightToMillimeter,
    _a[UnitSuffix.Quarter] = viewHeightToQuarter,
    _a[UnitSuffix.Inch] = viewHeightToInch,
    _a[UnitSuffix.Pica] = viewHeightToPica,
    _a[UnitSuffix.Point] = viewHeightToPoint,
    _a[UnitSuffix.REM] = viewHeightToREM,
    _a[UnitSuffix.EM] = viewHeightToEM,
    _a[UnitSuffix.ViewWidth] = viewHeightToViewWidth,
    _a[UnitSuffix.ViewHeight] = noConvert,
    _a[UnitSuffix.ViewMin] = viewHeightToViewMin,
    _a[UnitSuffix.ViewMax] = viewHeightToViewMax,
    _a);
//# sourceMappingURL=view-height.js.map